jQuery.feature_import("js-climate",
    () => require("./climate.jsx"),
    mod => mod.feature_js_climate
);